import { API_MESSAGE_TEMPLATE_LIST, API_MESSAGE_TEMPLATE_DELETE, API_MESSAGE_TEMPLATE_DETAIL, API_MESSAGE_TEMPLATE_SAVE } from '@/common/constants';
import { get, post, del, put } from '@/utils/http';

export const getMessageTemplateList = (currentPage = 1, pageSize = 10, keyWord) => {
    return get(API_MESSAGE_TEMPLATE_LIST, { currentPage, pageSize, msgTemplateTitle: keyWord });
};

export const getMessageTemplateDetail = (messageTemplateId) => {
    return get(API_MESSAGE_TEMPLATE_DETAIL.replace(':messageTemplateId', messageTemplateId));
};

export const delMessageTemplate = (messageTemplateId) => {
    return del(API_MESSAGE_TEMPLATE_DELETE.replace(':messageTemplateId', messageTemplateId));
};

export const saveMessageTemplate = (messageTemplate) => {
    if(messageTemplate.id==undefined||messageTemplate.id==''){
        return post(API_MESSAGE_TEMPLATE_SAVE, messageTemplate);
    }else{
        return put(API_MESSAGE_TEMPLATE_SAVE, messageTemplate);
    }       
};

export const updMessageTemplate = (messageTemplate) => {
    return put(API_MESSAGE_TEMPLATE_SAVE, messageTemplate);
};
// MessageTemplate MESSAGE_TEMPLATE messageTemplate



// WEBPACK FOOTER //
// ./src/data-model/customer/messageTemplate-model.js